import { createApp } from 'vue'
import App from './App.vue'
import { createPinia } from 'pinia'

import "./assets/main.scss";
import './registerServiceWorker'

import router from './router'

const pinia = createPinia()

createApp(App)
    .use(router)
    .use(pinia)
    .mount('#app')

document.addEventListener("DOMContentLoaded", () => {
    const isBrowser = matchMedia("(display-mode: browser)").matches
    if (!isBrowser) window.resizeTo(651, 600)
})